export default __webpack_public_path__ + "static/media/faqs.ee0e0797.jpg";